import {createSvgIcon} from './utils'

export default createSvgIcon(
  <>
    <path
      clipRule="evenodd"
      d="M6 3.5C3.79086 3.5 2 5.29086 2 7.5C2 9.70914 3.79086 11.5 6 11.5H18C20.2091 11.5 22 9.70914 22 7.5C22 5.29086 20.2091 3.5 18 3.5H6ZM6 9.5C7.10457 9.5 8 8.60457 8 7.5C8 6.39543 7.10457 5.5 6 5.5C4.89543 5.5 4 6.39543 4 7.5C4 8.60457 4.89543 9.5 6 9.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M18 13.5C20.2091 13.5 22 15.2909 22 17.5C22 19.7091 20.2091 21.5 18 21.5H6C3.79086 21.5 2 19.7091 2 17.5C2 15.2909 3.79086 13.5 6 13.5H18ZM18 19.5C16.8954 19.5 16 18.6046 16 17.5C16 16.3954 16.8954 15.5 18 15.5C19.1046 15.5 20 16.3954 20 17.5C20 18.6046 19.1046 19.5 18 19.5Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </>,
  'OptionsIcon',
)
